module.exports = __webpack_public_path__ + "img/logo_horizontal.ee5107ec.png";